export const splitTime = (time: string | undefined): [number, number] => {
  const splitted = time
    ?.split(':')
    .filter(part => !!part)
    .map(part => +part);
  const [hours = 0, minutes = 0] = splitted ?? [];

  return [hours, minutes];
};
